import api from "app/lib/api";
import endpoints from "static/endpoints";

export const getArchivedReports = async (
  query,
  isExport = false,
  isDownloadReport = false
) => {
  let url = isExport
    ? `${endpoints.archivedReports.downloadList}?`
    : isDownloadReport
      ? `${endpoints.archivedReports.downloadReports}?`
      : `${endpoints.archivedReports.list}?`;

  const { page, pageSize, sorting, search, isFetch } = query || {};

  if (sorting?.length > 0) {
    const sortingQueries = sorting
      ?.map((sort) => {
        const { id, desc } = sort;
        const direction = desc ? "desc" : "asc";

        return `sort=${id}&order=${direction}&`;
      })
      ?.filter(Boolean)
      ?.join("");

    url += sortingQueries;
  }

  // if (filter) url += filter;
  if (search) url += `${search}&`;

  url += `page=${page}&pageSize=${pageSize}`;

  if (isExport || isDownloadReport) {
    return await api.get(url, { responseType: "blob" });
  } else if (isFetch) {
    const { data, meta } = await api.get(url);

    return { data, meta };
  }
};
